import i18next, { i18n as I18nInstance } from "i18next";
import type { SupportedLocale } from "./translations";
import { translations } from "./translations";

export type { ErrorMessageKey, SupportedLocale } from "./translations";

export const DEFAULT_LOCALE: SupportedLocale = "nl";

export const i18n: I18nInstance = i18next.createInstance();

// eslint-disable-next-line stencil/ban-side-effects
void i18n.init({
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  initImmediate: false,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: "ui",
  ns: ["ui", "errors"],
  resources: {
    nl: {
      ui: translations.nl.ui,
      errors: translations.nl.errors,
    },
    en: {
      ui: translations.en.ui,
      errors: translations.en.errors,
    },
  },
  // Disable the i18next support notice (console.info) to keep logs clean in consuming apps.
  showSupportNotice: false,
});

export const getLocale = (input?: string): SupportedLocale => {
  if (
    input !== undefined &&
    (Object.keys(translations) as SupportedLocale[]).includes(
      input as SupportedLocale,
    )
  ) {
    return input as SupportedLocale;
  }
  return DEFAULT_LOCALE;
};
